module.exports = "https://r.nearpod.com/assets/media/image/quiz-ecb74d4f37303d5a0fdec33913e776e2.svg";